import { render, staticRenderFns } from "./SendDocumentTemplateDetailModal.vue?vue&type=template&id=4a5ac3d4&lang=pug"
import script from "./SendDocumentTemplateDetailModal.vue?vue&type=script&lang=ts"
export * from "./SendDocumentTemplateDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports